const filterLabels = {
    name: 'Name',
    domain: 'Domain',
    dr: 'DR',
    ok: 'OK',
    ot: 'OT',
    price: 'Price',
    rel: 'Rel',
    turn_around: 'Turn-Around',
    vendor: 'Vendor',
  };

  const vendorLabels = {
    ant: 'ANT',
    dws: 'DWS',
    fiv: 'FIV',
    int: 'INT',
    tok: 'TOK',
  };

  const vendorOptions = [
    { value: '', label: 'All' },
    { value: 'ant', label: 'ANT' },
    { value: 'dws', label: 'DWS' },
    { value: 'fiv', label: 'FIV' },
    { value: 'int', label: 'INT' },
    { value: 'tok', label: 'TOK' },
  ];

  export { filterLabels, vendorLabels, vendorOptions };